<img
    [ngSrc]="imageName"
    [width]="width"
    [height]="height"
    [loading]="priority ? 'eager' : 'lazy'"
    [attr.alt]="alt"
    [attr.title]="title"
    [ngStyle]="{ width: width, height: height }"
/>
